import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { Provider } from 'react-redux';
import './styles/index.less';
import '../src/assets/style/global.css'
import { store } from './store/store';
import ProductAPIFetcher from './store/hiddenApiListener';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
    <ProductAPIFetcher />
      <App />
    </BrowserRouter>
  </Provider>
);
